export const APP_NAME = "企业电子设备管理";
export const APP_VERSION = "0.1.0";
export const SOP_VERSION = "V2.7";
export const DESIGN_VERSION = "V1.54.7";
